import { useCallback } from 'react';
import { useMobileDetection } from '@/hooks/useMobileDetection';
import { LeftPanel } from './LeftPanel';
// import { LazyMapView } from '@/components/map/LazyMapView';
import { MapView } from '@/components/map/MapView';
import { WardInfoPopup } from '@/components/wards/WardInfoPopup';
import { WardInfoSheet } from '@/components/wards/WardInfoSheet';
import { useWardStore } from '@/stores/wardStore';
import { useUIStore } from '@/stores/uiStore';
import type { WardInfo } from '@/types/ward';

export function AppLayout() {
  const { isMobile } = useMobileDetection();
  const selectedWard = useWardStore((state) => state.selectedWard);
  const selectWard = useWardStore((state) => state.selectWard);
  const isPanelOpen = useUIStore((state) => state.isPanelOpen);

  const handleWardSelect = useCallback((ward: WardInfo) => {
    selectWard(ward);
  }, [selectWard]);

  return (
    <div className="h-screen w-screen overflow-hidden bg-gray-50">
      {/* Main content */}
      <div className="relative flex h-screen">
        {/* Left Panel */}
        <LeftPanel />

        {/* Map Container */}
        <main
          className={`relative flex-1 transition-all duration-300 ${
            !isMobile && isPanelOpen ? 'ml-0' : 'ml-0'
          }`}
        >
          <MapView
            onWardSelect={handleWardSelect}
            selectedWardId={selectedWard?.objectid}
            className="h-full w-full"
          />
        </main>

        {/* Ward Information Display */}
        {selectedWard && (
          <>
            {isMobile ? (
              <WardInfoSheet ward={selectedWard} />
            ) : (
              <WardInfoPopup ward={selectedWard} />
            )}
          </>
        )}
      </div>

      {/* Mobile Bottom Navigation */}
      {isMobile && (
        <div className="fixed bottom-0 left-0 right-0 z-20 bg-white shadow-lg">
          {/* Mobile navigation will be added here */}
        </div>
      )}
    </div>
  );
}
